import React, { useState, useEffect } from "react";
import AccessImg from "./ToolsDetails";

const Access = ({ readTime }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 767);
      setIsDesktop(window.innerWidth > 767);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="flex flex-col items-center md:mt-10 md:flex-row md:justify-between xl:px-[120px] md:px-[30px] sm:px-[30px]">
      <div className="px-10 py-10 bg-gray-100 mx-auto">
        {isMobile && (
          <div className="lg:mt-12 md:px-20">
            <AccessImg readTime={readTime} />
          </div>
        )}
        {isDesktop && (
          <div className="mx-auto">
            <AccessImg readTime={readTime} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Access;
